import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import { ApiGetCall, ApiGetHeaders, ApiPostCall } from "../../JS/Connector";
import { CamelCaseWithSpaces, typewatch, LogInSchoolID, formatDateToMMDDYYYY, transformNameOfCol, formatDateToUsaMMDDYYYY, getTypeWatchDelay } from "../../JS/Common";
import { useState } from "react";
import Deletepopup from "../../Components/Deletepopup";
import AlertsComp from "../../Components/AlertsComp";
import { DeviceDetailsPopup } from "../../Components/DeviceDetailsPopup";
import Pagination from "react-js-pagination";
import CustomizationPopup from "../../Components/CustomizationPopup";
import UserDetailsPopup from "../../Components/UserDetailsPopup";
import { log } from "../../JS/Logger";
import PageHead from "../../Components/PageHead";
import useConfig from "../../Hooks/useConfig";
import { useStickyAction } from "../../Hooks";

export function IndexUsers() {
    const { is_enterprise, department, grade, student_email,
        parent_guardian_name, parent_guardian_email, parent_guardian_number,
        show_device_complete_club, parent_name, parent_email, parent_phone,
        show_FUA_table_header, show_import_export_nav_btn, dcc_module_text } = useConfig();
    const [AllUsers, setAllUsers] = useState([]);
    const [Alerts, setAlerts] = useState("");
    const [isshowpopup, setisshowpopup] = useState(false);
    const [deleteusershow, setdeleteusershow] = useState(false);
    const [GridData, setGridData] = useState({
        SearchString: "",
        sortbykey: "",
        sortbyflag: "desc",
        Userid: "",
        DeleteUserId: "",
        TicketId: null
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const showPagination = AllUsers.length > 0;
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [UserModal, setUserModal] = useState(false)
    const [Userid, setUserid] = useState('');
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    useEffect(() => {
        ApiGetHeaders(5, setColumnNames)
    }, []);
    useEffect(() => {
        GetAllUsers(GridData.sortbykey, GridData.SearchString, false);
    }, [currentPage, LimitForPagination]);

    async function ExportUsersCall(flag) {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
            setAlerts(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
        }, 2000);

        setTimeout(() => {
            setAlerts(<AlertsComp show={false} />);
        }, 5000);

        setTimeout(() => {
            ApiGetCall(`/utilizers/export-legacy?schoolId=${LogInSchoolID}&flag=${flag}`)
        }, 0)
    }

    function renderContentForColumn(columnName, item) {
        const deviceSerials = item?.inventories?.filter(inventory => inventory?.device_flag != 3); // Non-loaner devices
        const loanerSerials = item?.inventories?.filter(inventory => inventory?.device_flag == 3); // Loaners only
        const contentMap = {
            "user_first_name": item?.device_user_first_name || '-',
            "user_middle_name": item?.device_user_middle_name || '-',
            "user_last_name": item?.device_user_last_name || '-',
            "Grade": item?.[grade] || '-',
            "Department": item.department || '-',
            "Student_Email": item.student_email || '-',
            "Device_Serial_#": (
                <span>
                    {deviceSerials.length > 0 ? (
                        deviceSerials.map((inventory, index) => (
                            <span key={index} onClick={() => {
                                setGridData({ ...GridData, Userid: inventory.id, TicketId: inventory.ticket_id ? inventory.ticket_id : null });
                                setisshowpopup(true);
                            }} className="cursor-pointer">
                                {index > 0 && ", "}
                                <u className={`${inventory?.ticket_flag == "1" ? "redText" : ""}`}>{inventory?.serial_number} {inventory?.asset_tag && '(' + inventory.asset_tag + ')'}</u>
                            </span>
                        ))
                    ) : (
                        <>-</> // Ensures "-" is shown if there are no regular devices
                    )}
                </span>
            ),
            "Loaner_Serial_#": (
                <span>
                    {loanerSerials.length > 0 ? (
                        loanerSerials.map((inventory, index) => (
                            <span key={index} onClick={() => {
                                setGridData({ ...GridData, Userid: inventory.id, TicketId: inventory.ticket_id ? inventory.ticket_id : null });
                                setisshowpopup(true);
                            }} className="cursor-pointer">
                                {index > 0 && ", "}
                                <u className={`${inventory?.ticket_flag == "1" ? "redText" : ""}`}>{inventory?.serial_number} {inventory?.asset_tag && '(' + inventory.asset_tag + ')'}</u>
                            </span>
                        ))
                    ) : (
                        <>-</> // Ensures "-" is shown if there are no loaners
                    )}
                </span>
            ),
            "Student_num": item.student_num || '-',
            "Parent_guardian_name": item.parent_guardian_name || '-',
            "Parent_phone_number": item.parent_phone_number || '-',
            "Parent_Guardian_Email": item.parent_guardian_email || '-',
            "created_at": item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-',
            ...(show_device_complete_club && { "Parental_coverage": item.parental_coverage == "1" ? "Yes" : "No" }),
        };
        return contentMap[columnName] || null;
    }
    async function GetAllUsers(sortbykey, searchstring, toogleSort) {
        if (searchstring == "") {
            searchstring = null;
        }
        if (!GridData.SearchString) GridData.SearchString = null;
        if (sortbykey && toogleSort) GridData.sortbyflag = GridData.sortbyflag == "asc" ? "desc" : "asc";
        if (!sortbykey) sortbykey = "id";
        var joinedString = null;
        if (columnNames.length > 0) {
            const replacePlaceholder = (str) => str.replace(/__HASH__/g, '#');
            const filteredColumns = columnNames.filter((columnName) => columnName !== "Loaner_Serial_#");
            filteredColumns.push('Asset_Tag');
            joinedString = filteredColumns.map((columnName) => replacePlaceholder(columnName)).join('~').replace(/#/g, 'num');
        }
        typewatch(async function () {
            setLoading(true)
            await ApiGetCall(`/utilizers/data?schoolId=${LogInSchoolID}&search=${searchstring}&sortBy=${sortbykey}&sortOrder=${GridData.sortbyflag}&page=${currentPage}&perPage=${LimitForPagination}&data=${joinedString}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs?.msg?.total);
                    setAllUsers(responseRs?.msg?.data?.length ? responseRs?.msg?.data : [])
                    setLoading(false);

                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }

    async function DeleteUser() {
        setLoading(true);
        var raw = "";
        await ApiPostCall("/utilizers/delete/" + GridData.DeleteUserId, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setdeleteusershow(false);
                if (responseRs.status == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"User Deleted Successfully."} />);
                    setTimeout(() => {
                        GetAllUsers(null, GridData.SearchString, false);
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const handleSortClick = (item) => {
        if (item == "user_first_name") {
            item = "device_user_first_name"
        }
        if (item == "user_middle_name") {
            item = "device_user_middle_name"
        }
        if (item == "user_last_name") {
            item = "device_user_last_name"
        }
        item = item.toLowerCase().split(' ').join('_');
        if (item !== 0) {
            GetAllUsers(item, GridData.SearchString, true)
            setGridData({ ...GridData, sortbykey: item })
        }
    };
    function handleSearchChange(e) {
        setGridData({ ...GridData, SearchString: e.target.value ? e.target.value : null });
        setCurrentPage(1);
        GetAllUsers(null, e.target.value, false);
    }
    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Device Users"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <div className="row my-2 pe-0 align-items-center">
                <div className="col-md-12 text-center justify-content-end align-items-end d-md-flex">
                    <a onClick={(e) => navigate("/import-export")} className="BlackFont cursor-pointer">
                        <label className="BorderBtn text-center me-0" title="Import Users">
                            Import Users<img src="/images/ImportInventory.svg" className="img-fluid ps-2" />
                        </label>
                    </a>
                    {AllUsers.length > 0 && (
                        <div className="BorderBtn ms-3 me-0" onClick={(e) => ExportUsersCall(1)} title="Export Users">
                            Export Users
                            <img src="/images/ExportInventory.svg" className="img-fluid ps-2" />
                        </div>
                    )}
                    {AllUsers.length > 0 && (
                        <div className="BorderBtn ms-3 me-0" onClick={(e) => ExportUsersCall(2)} title="Export User History">
                            Export User History
                            <img src="/images/ExportInventory.svg" className="img-fluid ps-2" />
                        </div>
                    )}
                    <label className='BorderBtn ms-3 text-center me-0' onClick={(e) => navigate("/addupdate-users")} title="Add User"> Add User
                        <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                    </label>
                </div>
                <div className="col-md-12">
                    {show_device_complete_club &&
                        <label className="theme-colorcode">* User has {dcc_module_text}</label>
                    } {" "}
                    <label className="redText">* A ticket has been created on the device</label>
                </div>
            </div>
            <div className="GridBox p-3">
                <div className="col-12 greyBox">
                    <div className="data-table-container" ref={tableWrapperRef}>
                        <table className="table data-table">
                            <thead className="GridHeader">
                                <tr>
                                    {columnNames?.map((item) => {
                                        let columnName = item.replace(/_/g, ' ');
                                        if (item == "Parental_coverage") {
                                            columnName = dcc_module_text;
                                        }
                                        const transformedName = transformNameOfCol(columnName);
                                        if (!transformedName) return null;
                                        return (
                                            item != "Device_Serial_#" && item != "Loaner_Serial_#" && item != "Parent_phone_number" ?
                                                <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}`} onClick={() => handleSortClick(item)}>
                                                    {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                                                    <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                </th>
                                                :
                                                <th key={item} scope="col" className='fw-600'>
                                                    {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                                                </th>
                                        );
                                    })}
                                    {show_FUA_table_header &&
                                        <th scope="col" className="fw-600" title=" Fair Use Acknowledgment">FUA</th>
                                    }
                                    <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>
                                        Action
                                        <img src="/images/EditHeaderIcon.svg" className="cursor-pointer  img-fluid ps-2 pe-5"
                                            title='Customize Headers' style={{ height: '25px' }}
                                            onClick={(e) => setCustomizationModal(true)} />
                                    </th>
                                </tr>
                            </thead >
                            <tbody>
                                {AllUsers && AllUsers.length > 0 ? (
                                    AllUsers.map((item, index) => (
                                        <tr key={index} className={`${item.studenthaveplan == 1 ? 'theme-colorcode' : ''} OddEvenClass tableBorderHide`}>
                                            {columnNames?.map(header => {
                                                let columnName = header.replace(/_/g, ' ');
                                                if (header == "Parental_coverage") columnName = dcc_module_text;
                                                const transformedName = transformNameOfCol(columnName);
                                                if (!transformedName) return null;

                                                return (
                                                    <td className="py-12" key={header}>
                                                        {renderContentForColumn(header, item)}
                                                    </td>
                                                );
                                            })}
                                            {show_FUA_table_header &&
                                                <td className="py-12">
                                                    {item.studentagreepolicy == 1 ? 'Yes' : item.studentagreepolicy == 0 ? 'No' : '-'}
                                                </td>
                                            }
                                            <td className={`py-12 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                <img src="/images/EditIconNew.svg" title="Edit User" className="img-fluid pe-2 cursor-pointer" utilizerid={item.id} onClick={(e) => { navigate("/addupdate-users/?id=" + item.id) }} />
                                                <img src="/images/DeleteIcon.svg" title="Delete User" className="img-fluid cursor-pointer" utilizerid={item.id} onClick={(e) => { setdeleteusershow(true); setGridData({ ...GridData, DeleteUserId: item.id }) }} />
                                                <img src="/images/InfoIcon.svg" title="Show User History" className="img-fluid cursor-pointer px-2" utilizerid={item.id} onClick={(e) => { setUserid(item.id); setUserModal(true) }} />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="col-12 text-center p-2">
                                        <td colSpan={12}>No Record Found</td>
                                    </tr>
                                )}

                            </tbody>
                        </table>
                    </div>
                </div >
                {showPagination && (
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        itemsCountPerPage={LimitForPagination}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                )}

            </div>

            {UserModal && <UserDetailsPopup isShow={UserModal} ClosePopup={(e) => setUserModal(false)} userid={Userid} />}
            {isshowpopup && <DeviceDetailsPopup Showbuttons={1} ticketid={GridData.TicketId} createticketbutton={true} deviceid={GridData.Userid} activetab="device" isShow={isshowpopup} ClosePopup={(e) => setisshowpopup(false)} />}
            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Device Users'} GetCall={() => ApiGetHeaders(5, setColumnNames)} />}
            <Deletepopup text={`You won't be able to revert this!`} deletePopup={deleteusershow} deletePart={DeleteUser} DeleteShowClose={(e) => setdeleteusershow(false)}></Deletepopup>
        </React.Fragment>
    )
}
